// -- React Libraries
import React from 'react';

// -- Styles
import StyleWrapper from "./Wrapper";

// -- Components
import CircularProgressBar from "../../../components/CircularProgressBar/index";

// -- Resources
import GreenDownArrow from '../../../image/arrow_green.1.png';
import GreenUpArrow from '../../../image/arrow_green.png';
import RedUpArrow from '../../../image/arrow red.1.png';
import RedDownArrow from '../../../image/arrow red.png';

export default class CampaignDashboard extends React.Component {
    constructor (props) {
        super(props);

        this.CPA = "---";
        this.CR = "---";

        let PerformanceCPAs = 0;
        let PerformanceCRs = 0;
        let DiscoveryCPAs = 0;
        let DiscoveryCRs = 0;
        let NumberOfPerformace = 0;
        let NumberOfDiscovery = 0;
        
        let sumRecords = function (data) {
            if (data.pTotalData && data.pTotalData.total)
            {
                PerformanceCPAs += data.pTotalData.total.avgCPA.amount;
                PerformanceCRs += data.pTotalData.total.conversionRate;
                NumberOfPerformace += 1;
            }

            if (data.dTotalData && data.dTotalData.total) {
                DiscoveryCPAs += data.dTotalData.total.avgCPA.amount;
                DiscoveryCRs += data.dTotalData.total.conversionRate;
                NumberOfDiscovery += 1;
            }
        }
        let roundTo2Places = function (number) {
            return Math.round(number * 100) / 100;
        }

        if (Array.isArray(props.data)) {
            props.data.map( (data) => { sumRecords(data); } );
        }
        else {
            console.table(props.data);
            sumRecords(props.data);
        }

        if (NumberOfPerformace > 0) {
            PerformanceCPAs = PerformanceCPAs / NumberOfPerformace;
            PerformanceCRs = PerformanceCRs / NumberOfPerformace;
        }
        if (NumberOfDiscovery > 0) {
            DiscoveryCPAs = DiscoveryCPAs / NumberOfDiscovery;
            DiscoveryCRs = DiscoveryCRs / NumberOfDiscovery;
        }

        this.CPA = (PerformanceCPAs + DiscoveryCPAs);
        this.CR = (PerformanceCRs + DiscoveryCRs);

        this.CPA = this.CPA > 0 ? roundTo2Places(this.CPA / (NumberOfPerformace > 0 && NumberOfDiscovery > 0 ? 2 : 1)) : -1;
        this.CR = this.CR > 0 ? roundTo2Places(this.CR / (NumberOfPerformace > 0 && NumberOfDiscovery > 0 ? 2 : 1) * 100) : -1;
    }

    render() {
        return (
            <StyleWrapper className={this.props.className}>
                <dl className="cost">
                    <dt>获客成本</dt>
                    <dd>
                        美金 {this.CPA >= 0 ? this.CPA : "--"}
                        <img src={ RedUpArrow } className="arrow-up"/>
                    </dd>
                </dl>

                <dl className="rate">
                    <dt>转化率</dt>
                    <dd>
                        
                        {this.CR >= 0 ? this.CR : "--"} %&nbsp;
                        <CircularProgressBar
                            arcWidth={21}
                            arcData={[
                                { percentage: 1, strokeWidth: 2, strokeColor: "#cfc9de" },
                                { percentage: this.CR >= 0 ? this.CR / 100 : 0, strokeWidth: 2, strokeColor: "#9995a2" }
                            ]}
                            strokeWidth={2}
                            strokeColor="#9995a2"
                            percentage={this.CR >= 0 ? this.CR : 0}
                        />
                    </dd>
                </dl>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/CampaignList/CampaignDashboard/index.js